<div class="container">
    <div class="forgot-password-form">
      <div class="h6">Forgot Password?</div>
      <p class="subtitle p5">Enter your registered email and we’ll send you a link to reset it.</p>
      
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email">Email<span class="required">*</span></label>
          <input 
            type="email" 
            id="email" 
            class="form-control" 
            [ngClass]="{'error': hasEmailError() || errorMessage}" 
            placeholder="Enter your registered email address" 
            formControlName="email">
        </div>
        
        <!-- Show validation errors specific to email field -->
        <app-error-message *ngIf="getEmailErrorMessage()">Enter a valid email address</app-error-message>
        
        <!-- Show general error messages from API -->
        <app-error-message *ngIf="errorMessage && !getEmailErrorMessage()">{{ errorMessage }}</app-error-message>

        <button type="submit" class="btn btn-primary btn-large" [ngClass]="{'disabled': forgotPasswordForm.invalid || loading}" [disabled]="forgotPasswordForm.invalid || loading">
          <span *ngIf="!loading">Send Reset Link</span>
          <span *ngIf="loading" class="loader"></span>
        </button>
      </form>
      
      <a routerLink="/login" class="back-to-login btn btn-tertiary btn-small">Go back to login</a>
    </div>
  </div>
  
